import paymentReducer from './paymentSlice';
import * as paymentActions from './actions';
import * as paymentSelector from './selector';

export {
  paymentActions,
  paymentSelector
}

export default paymentReducer